import {
    post,
    get
} from "../utils/http";

const yysy = {
    createModel: params => post('/yysy/createModel',params),
    trainingModel: params => post('/yysy/trainingModel',params),
    listModel: params => post('/yysy/listModel',params),
    pageModel: params => get('/yysy/pageModel',params),
    delModel: params => post('/yysy/delModel',params),
    evaluate: params => post('/yysy/eval',params),
    updateModel: params => post('/yysy/updateModel',params),
    getModelSampleList: params => post('/ModelSample/list',params),
    deleteModelSample: params => post('/ModelSample/delete',params),
    updateModelSample: params => post('/ModelSample/update',params),

}

export default yysy;


// WEBPACK FOOTER //
// ./src/api/yysy.js